export default __webpack_public_path__ + "static/media/waves.bff2741f.mp3";